import { primitives } from "./primitives";

export const themeLight = {
  contentPrimary: {
    value: primitives.colorGray900,
  },
  contentSecondary: {
    value: primitives.colorGray600,
  },
  contentTertiary: {
    value: primitives.colorGray500,
  },
  backgroundPrimary: {
    value: primitives.colorGray50,
  },
  backgroundSecondary: {
    value: primitives.colorGray200,
  },
  borderBorderPrimary: {
    value: primitives.colorOpacityBlack300,
  },
  contentPlaceholder: {
    value: primitives.colorGray300,
  },
  contentWhite: {
    value: primitives.colorBaseWhite,
  },
  backgroundDialog: {
    value: primitives.colorBaseWhite,
  },
  contentPositive: {
    value: primitives.colorBrandGreen500,
  },
  contentNegative: {
    value: primitives.colorBrandRed500,
  },
  tagTagDefault: {
    value: primitives.colorGray200,
  },
  tagTagSelected: {
    value: primitives.colorBrandBlue50,
  },
  contentLink: {
    value: primitives.colorBrandBlue500,
  },
  backgroundLinkSecondary: {
    value: primitives.colorBrandBlue50,
  },
  contentDisable: {
    value: primitives.colorGray400,
  },
  backgroundDisable: {
    value: primitives.colorGray300,
  },
  backgroundLinkPrimary: {
    value: primitives.colorBrandBlue500,
  },
  contentNotification: {
    value: primitives.colorBrandRed500,
  },
  contentLike: {
    value: primitives.colorBrandPink500,
  },
  contentAbsolutely: {
    value: primitives.colorBaseWhite,
  },
  backgroundSurfaceInput: {
    value: primitives.colorBaseWhite,
  },
  backgroundAbsolutely: {
    value: primitives.colorBaseWhite,
  },
  contentBlack: {
    value: primitives.colorBaseBlack,
  },
  borderBorderSecondary: {
    value: primitives.colorOpacityBlack200,
  },
  backgroundHover: {
    value: primitives.colorGray400,
  },
  backgroundWhite: {
    value: primitives.colorBaseWhite,
  },
  backgroundBlack: {
    value: primitives.colorBaseBlack,
  },
  backgroundOverlay: {
    value: primitives.colorOpacityBlack800,
  },
  contentTellernovel: {
    value: primitives.colorBrandRedTn,
  },
  miscellaneousXxxx: {
    value: primitives.colorBaseWhite,
  },
};

export const themeDark = {
  contentPrimary: {
    value: primitives.colorGray100,
  },
  contentSecondary: {
    value: primitives.colorGray400,
  },
  contentTertiary: {
    value: primitives.colorGray500,
  },
  backgroundPrimary: {
    value: primitives.colorGray950,
  },
  backgroundSecondary: {
    value: primitives.colorBaseBlack,
  },
  borderBorderPrimary: {
    value: primitives.colorOpacityWhite300,
  },
  contentPlaceholder: {
    value: primitives.colorGray700,
  },
  contentWhite: {
    value: primitives.colorBaseWhite,
  },
  backgroundDialog: {
    value: primitives.colorGray900,
  },
  contentPositive: {
    value: primitives.colorBrandGreen500,
  },
  contentNegative: {
    value: primitives.colorBrandRed500,
  },
  tagTagDefault: {
    value: primitives.colorGray950,
  },
  tagTagSelected: {
    value: primitives.colorBrandBlue50,
  },
  contentLink: {
    value: primitives.colorBrandBlue500,
  },
  backgroundLinkSecondary: {
    value: primitives.colorBrandBlue200,
  },
  contentDisable: {
    value: primitives.colorGray600,
  },
  backgroundDisable: {
    value: primitives.colorGray800,
  },
  backgroundLinkPrimary: {
    value: primitives.colorBrandBlue500,
  },
  contentNotification: {
    value: primitives.colorBrandRed500,
  },
  contentLike: {
    value: primitives.colorBrandPink500,
  },
  contentAbsolutely: {
    value: primitives.colorBaseBlack,
  },
  backgroundSurfaceInput: {
    value: primitives.colorGray900,
  },
  backgroundAbsolutely: {
    value: primitives.colorBaseBlack,
  },
  contentBlack: {
    value: primitives.colorBaseBlack,
  },
  borderBorderSecondary: {
    value: primitives.colorOpacityWhite200,
  },
  backgroundHover: {
    value: primitives.colorGray700,
  },
  backgroundWhite: {
    value: primitives.colorBaseWhite,
  },
  backgroundBlack: {
    value: primitives.colorBaseBlack,
  },
  backgroundOverlay: {
    value: "#1e1e1ecc",
  },
  contentTellernovel: {
    value: primitives.colorBrandRedTn,
  },
  miscellaneousXxxx: {
    value: primitives.colorBaseWhite,
  },
};
